import PropTypes from 'prop-types';
import getRoute from 'components/searchAds/SearchLayout/getRoute';

import { reducer as routeReducer } from './duck';
import routeActions from './actions';
import mapStateToProps from './mapStateToProps';

const propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  changeFilters: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  changeSort: PropTypes.func.isRequired,
  cms: PropTypes.object,
  initialForm: PropTypes.object.isRequired,
  storageKey: PropTypes.string.isRequired,
  userSearchType: PropTypes.string.isRequired,
  withPromoBanner: PropTypes.bool.isRequired,
  withExtraFilters: PropTypes.bool.isRequired,
  withInitialAdResultsAmount: PropTypes.bool.isRequired,
  withWelcomeBanner: PropTypes.bool.isRequired,
  numberOfResultsPerPage: PropTypes.number.isRequired,
  experiment: PropTypes.object,
};

const { Component, actions, reducer } = getRoute({
  mapStateToProps,
  propTypes,
  routeReducer,
  routeActions,
});

export { actions, reducer };
export default Component;
